import { useState } from "react";
import { DatePickerInput, DatePickerInputProps } from "@mantine/dates";
import { ActionIcon, Group } from "@mantine/core";
import {
  IconCalendar,
  IconChevronLeft,
  IconChevronRight,
} from "@tabler/icons-react";
import dayjs from "dayjs";

type DatePickerWithShiftProps = Omit<
  DatePickerInputProps,
  "value" | "onChange"
> & {
  value?: Date | null;
  onChange?: (date: Date | null) => void;
};

export default function DatePickerWithShift({
  value,
  onChange,
  ...props
}: DatePickerWithShiftProps) {
  const [selectedDate, setSelectedDate] = useState<Date | null>(value ?? null);

  const handleChange = (date: Date | null) => {
    setSelectedDate(date);
    onChange?.(date);
  };

  const shiftDate = (days: number) => {
    if (!selectedDate) return;
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + days);
    handleChange(newDate);
  };

  return (
    <DatePickerInput
      value={selectedDate}
      onChange={(d) => handleChange(d as any)}
      highlightToday
      rightSection={
        <Group gap={2} wrap="nowrap" ml={-24}>
          <ActionIcon
            onClick={() => shiftDate(-1)}
            variant="default"
            size="sm"
            disabled={props.disabled}
          >
            <IconChevronLeft size={16} />
          </ActionIcon>
          <ActionIcon
            onClick={() => shiftDate(1)}
            variant="default"
            size="sm"
            disabled={props.disabled}
          >
            <IconChevronRight size={16} />
          </ActionIcon>
        </Group>
      }
      leftSection={<IconCalendar size={16} />}
      clearable={false}
      valueFormat={`ddd, MMMM DD${
        dayjs(selectedDate).isSame(Date.now(), "year") ? "" : ", YYYY"
      }`}
      {...props}
      style={{ minWidth: 150, textAlign: "center" }}
    />
  );
}
